const publish = (components) => {
  Object.keys(components).forEach((name) => {
    const keys = name.split('.')
    const last = keys.pop()
    const scope = keys.reduce((parent, key) => {
      parent[key] = parent[key] || {}
      return parent[key]
    }, window)

    scope[last] = components[name]
  })
}

export default publish
